import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

import { open } from './actions'

export { open }

export default Loadable(() => import('./LoanAdd'))
